/**
 * Simple markdown parser for comments
 * Supports: bold, italic, links, inline code, lists
 * Runs before sanitization - only safe patterns processed
 */

export const parseMarkdown = (text) => {
  if (!text) return '';
  
  let html = text;
  
  // Escape HTML to prevent injection before processing markdown
  html = escapeHtml(html);
  
  // Bold: **text** or __text__
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/__(.+?)__/g, '<strong>$1</strong>');
  
  // Italic: *text* or _text_
  html = html.replace(/\*(.+?)\*/g, '<em>$1</em>');
  html = html.replace(/_(.+?)_/g, '<em>$1</em>');
  
  // Links: [text](url)
  html = html.replace(/\[(.+?)\]\((https?:\/\/[^\s]+)\)/g, '<a href="$2">$1</a>');
  
  // Inline code: `code`
  html = html.replace(/`(.+?)`/g, '<code>$1</code>');
  
  // Line breaks: preserve newlines as <br>
  html = html.replace(/\n/g, '<br>');
  
  return html;
};

const escapeHtml = (text) => {
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  };
  return text.replace(/[&<>"']/g, (char) => map[char]);
};
